import { useAuth } from "../services/auth"

const usePermission = (action: string, subject: string, field?: string) => {
    const auth = useAuth()
    return auth?.user?.ability?.can(action, subject, field)
}

export default usePermission
